<template>
  <div>
    <CSelect
      label="地域简称"
      v-model="regionSel"
      :options="regionOptions"
      placeholder="请选择地域"
    />
    <CInput
      v-if="regionSel === '__custom__'"
      label="地域简称（手动输入）"
      v-model="regionCustom"
      placeholder="如 jp / hk / fs"
      class="mb-1"
    />
    <CInput label="ISP（运营商）" v-model="isp" placeholder="如 aliyun / qcloud / psychz" />
    <CInput label="计算模块花名" v-model="module" placeholder="如 core / yghdy（模块/集群标识）" />
    <CInput label="路由器花名" v-model="alias" placeholder="如 core1 / hk1 / ct1" />
    <CSelect
      label="路由器类型（记录到系统，不进名字）"
      v-model="role"
      :options="roleOptions"
      placeholder="请选择类型"
    />
    <CInput
      label="最终名称（可手动微调）"
      :value="innerName"
      @update:value="v => $emit('input', v)"
    />
    <CAlert color="info" fade class="mb-0">
      命名规范：<code>{地域}-{ISP}-{计算模块花名}-router-{花名}</code>，例：
      <code>sz-core-sz1-router-core1</code>。
      类型（transit/core/peer/pppoe/internal/access）仅记录在系统中。
    </CAlert>
  </div>
</template>

<script>
const ROLES = ['transit', 'core', 'peer', 'pppoe', 'internal', 'access']

export default {
  name: 'RouterNameBuilder',
  props: {
    value: { type: String, default: '' }
  },
  data() {
    return {
      regions: [],
      regionSel: '',
      regionCustom: '',
      isp: '',
      module: '',
      role: '',
      alias: ''
    }
  },
  computed: {
    roleOptions() {
      return [
        { value: 'transit', label: 'transit（出口）' },
        { value: 'core', label: 'core（核心）' },
        { value: 'peer', label: 'peer（互联）' },
        { value: 'pppoe', label: 'pppoe（拨号）' },
        { value: 'internal', label: 'internal（内网）' },
        { value: 'access', label: 'access（接入）' }
      ]
    },
    regionOptions() {
      const opts = this.regions
        .filter(g => g.code)
        .map(g => ({ value: g.code, label: `${g.name} (${g.code})` }))
      opts.push({ value: '__custom__', label: '手动输入…' })
      return opts
    },
    builtName() {
      const region = this.regionSel === '__custom__' ? this.regionCustom : this.regionSel
      if (!region || !this.isp || !this.module || !this.alias) return ''
      return `${region}-${this.isp}-${this.module}-router-${this.alias}`.toLowerCase()
    },
    innerName() {
      return this.builtName || this.value
    }
  },
  watch: {
    builtName(val) {
      if (val) this.$emit('input', val)
    },
    role(val) {
      this.$emit('role-change', val)
    },
    value(val) {
      // 外部传入新值且不是自己组装出来的（如改名弹窗切换到另一台路由器）→ 重新解析回填
      if (!val || val === this.builtName) return
      this.parseInto(val)
    }
  },
  mounted() {
    if (this.value) this.parseInto(this.value)
    this.loadRegions()
  },
  methods: {
    parseInto(name) {
      const parts = name.toLowerCase().split('-')
      // 定位 router 关键字（旧5段 idx=2, 新5段/过渡6段 idx=3）
      let routerIdx = null
      for (const i of [2, 3]) {
        if (parts[i] === 'router') { routerIdx = i; break }
      }
      if (routerIdx === null || parts.length < routerIdx + 2) {
        return
      }
      if (routerIdx === 2 && !ROLES.includes(parts[3])) {
        return // 旧格式 role 段非法
      }
      const regionCode = parts[0]
      const known = this.regions.some(g => g.code === regionCode)
      this.regionSel = known ? regionCode : '__custom__'
      this.regionCustom = known ? '' : regionCode
      this.isp = parts[1]
      this.module = routerIdx === 3 ? parts[2] : ''
      if (routerIdx === 2) {
        // 旧5段: [region, isp, router, role, alias...]
        this.role = parts[3]
        this.alias = parts.slice(4).join('-')
      } else if (parts.length >= 6 && ROLES.includes(parts[4])) {
        // 过渡6段: [region, isp, module, router, role, alias...]
        this.role = parts[4]
        this.alias = parts.slice(5).join('-')
      } else {
        // 新5段: [region, isp, module, router, alias...]
        this.role = ''
        this.alias = parts.slice(4).join('-')
      }
    },
    async loadRegions() {
      try {
        const res = await this.$axios.get('user/region/list')
        if (res.data.code === 200) {
          this.regions = res.data.data || []
          // 地域列表到达后修正下拉选中项（custom → 已知 code）
          if (this.value) this.parseInto(this.value)
        }
      } catch (e) { /* ignore */ }
    }
  }
}
</script>
